import * as React from 'react'
import { LazyLoadImage, LazyLoadImageProps } from 'react-lazy-load-image-component'

export type ImageProps = LazyLoadImageProps

const Image: React.FunctionComponent<ImageProps> = (props) => <LazyLoadImage {...props} />

export default Image
